import { create } from "zustand";
import { ChatService } from "../services/admin/services/chatService";
import { TransferRequestService } from "../services/admin/services/transferRequestService";
import { serviceRegistry } from "../services/core/serviceRegistry";
import { logger } from "../utils/logger";

interface AdminNotificationState {
  unreadChatCount: number;
  fetchUnreadChatCount: () => Promise<void>;
  setUnreadChatCount: (count: number) => void;

  pendingTransferRequestCount: number;
  fetchPendingTransferRequestCount: () => Promise<void>;
  setPendingTransferRequestCount: (count: number) => void;
}

export const useAdminNotificationStore = create<AdminNotificationState>(
  (set, _get) => ({
    unreadChatCount: 0,
    fetchUnreadChatCount: async () => {
      try {
        // Check if admin client is initialized
        if (!serviceRegistry.isAdminInitialized()) {
          logger.warn("Admin services not initialized yet");
          return;
        }

        const chatService = new ChatService(serviceRegistry.getAdminClient());
        const result = await chatService.getUnreadCount();

        if (result.success) {
          set({ unreadChatCount: result.data.count });
        } else {
          logger.error(
            "Failed to fetch unread chat count:",
            result.error?.message,
          );
        }
      } catch (error) {
        logger.error("Failed to fetch unread chat count:", error);
      }
    },
    setUnreadChatCount: (count: number) => {
      set({ unreadChatCount: count });
    },

    pendingTransferRequestCount: 0,
    fetchPendingTransferRequestCount: async () => {
      try {
        // Check if admin client is initialized
        if (!serviceRegistry.isAdminInitialized()) {
          logger.warn("Admin services not initialized yet");
          return;
        }

        const transferRequestService = new TransferRequestService(
          serviceRegistry.getAdminClient(),
        );
        const result = await transferRequestService.getPendingCount();

        if (result.success) {
          set({ pendingTransferRequestCount: result.data });
        } else {
          logger.error(
            "Failed to fetch pending transfer request count:",
            result.error?.message,
          );
        }
      } catch (error) {
        logger.error("Failed to fetch pending transfer request count:", error);
      }
    },
    setPendingTransferRequestCount: (count: number) => {
      set({ pendingTransferRequestCount: count });
    },
  }),
);
